<template>
  <div class="row">
    <div class="col-md-4 mb-4">

      <div class="card h-100">
        <div class="card-header bg-primary text-white">
          <div class="card-title mb-0">{{domain.pingUrl}}</div>
        </div>
        <div class="card-body">
          <canvas ref="chart"></canvas>
        </div>
      </div>
    </div>
    <div class="col-md-4 mb-4">
      <h4>Статусы</h4>
      <table class="table table-striped table-sm">
        <thead>
        <tr>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>Домен оплачен до:</td>
          <td>
            <span v-if="domain.domainExpiration">{{formatDate(domain.domainExpiration)}}</span>
            <span v-else>-</span>
          </td>
        </tr>
        <tr>
          <td>Сертификат доступен до:</td>
          <td>
            <span v-if="domain.certificateExpiration">{{formatDate(domain.certificateExpiration)}}</span>
            <span v-else>-</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps, onBeforeUnmount, onMounted, ref, watch} from "vue";
import {useDomainStore} from "@/store/domains";
import { Chart } from 'chart.js/auto'
import {useNotificationsStore} from "@/store/notifications";

const props  = defineProps({
  domainId: Number,
})

const domainStore = useDomainStore()
const domain = computed(() => domainStore.domain)
domainStore.getById(props.domainId)
domainStore.getMetrics({
  domainId: props.domainId,
  scheduleInterval: 'minute'
})


const chart = ref(null)
let chartInstance = null

const sortedPings = computed(() => {
  return [...domainStore.metrics].sort((a, b) =>
      new Date(a.updatedAt) - new Date(b.updatedAt) // Сортировка по возрастанию (новые справа)
  )
})

const formatTime = (dateString) => {
  const date = new Date(dateString)
  return date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  })
}
const formatDate = (isoString) => new Date(isoString).toLocaleDateString('ru-RU');

const initChart = () => {
  chartInstance = new Chart(chart.value.getContext('2d'), {
    type: 'line',
    data: {
      labels: sortedPings.value.map(p => formatTime(p.updatedAt)),
      datasets: [{
        label: 'Пинг (мс)',
        data: sortedPings.value.map(p => p.ping),
        borderColor: 'rgba(13, 110, 253, 1)',
        backgroundColor: 'rgba(13, 110, 253, 0.1)',
        tension: 0.1,
        fill: true
      }]
    },
    options: {
      responsive: true,
      animation: { duration: 0 },
      scales: {
        y: { beginAtZero: false },
        x: {
          ticks: {
            autoSkip: true,
            maxRotation: 45,
            minRotation: 45
          }
        }
      }
    }
  })
}

const updateChart = () => {
  chartInstance.data.labels = sortedPings.value.map(p => formatTime(p.updatedAt))
  chartInstance.data.datasets[0].data = sortedPings.value.map(p => p.ping)
  chartInstance.update()
}

onMounted(async () => {
  await domainStore.getMetrics({
    domainId: props.domainId,
    scheduleInterval: 'minute'
  })
  initChart()
})

onBeforeUnmount(() => {
  if (chartInstance) chartInstance.destroy()
})

// обновление данных
const notificationsStore = useNotificationsStore()

// обновление пинга
const domainMetricLog = computed(() => notificationsStore.debug['domain_metrics'])
notificationsStore.onDebug('domain_metrics')
watch(() => domainMetricLog.value, async () => {
  if(domainMetricLog.value.data.domainId === props.domainId) {
    await domainStore.getMetrics({
      domainId: props.domainId,
      scheduleInterval: 'minute'
    })
    updateChart()
  }
})

// обновление информации о домене
const domainLog = computed(() => notificationsStore.debug['domains'])
notificationsStore.onDebug('domains')
watch(() => domainLog.value, () => {
  if(domainLog.value.id === props.domainId && domainLog.value.type === 'update') {
    domainStore.getById(props.domainId)
  }
})
</script>
